import PropTypes from 'prop-types';

/** Placeholder until wired to CFS / API */
const DEFAULT_PROTOCOL_DOCUMENTS = [
  { id: 1, label: 'Structure Fire SOP.pdf', href: '#' },
  { id: 2, label: 'High-Rise Protocol.pdf', href: '#' },
];

const styles = {
  wrap: {
    borderRadius: 8,
    padding: '10px 12px',
    fontSize: 11,
    lineHeight: 1.35,
    background: '#fffbeb',
    border: '1px solid #fde68a',
    minWidth: 0,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    marginBottom: 8,
    fontSize: 10,
    fontWeight: 800,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: '#78716c',
  },
  headerIcon: {
    color: '#a8a29e',
    fontSize: 13,
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '8px 10px',
    borderRadius: 6,
    background: '#fff',
    border: '1px solid #e7e5e4',
  },
  rowIcon: {
    color: '#a8a29e',
    fontSize: 14,
    flexShrink: 0,
  },
  link: {
    color: '#2563eb',
    textDecoration: 'underline',
    fontSize: 12,
    fontWeight: 500,
    wordBreak: 'break-word',
  },
};

function CfsProtocolInsightCard({ documents = null }) {
  const list = documents?.length > 0 ? documents : [];

  return (
    <div style={styles.wrap}>
      <div style={styles.header}>
        <i className="fa fa-file-text-o" style={styles.headerIcon} aria-hidden />
        <span>Documents</span>
      </div>
      <div style={styles.list}>
        {list?.map((doc) => (
          <div key={doc.DocumentName} style={styles.row}>
            <i className="fa fa-file-text-o" style={styles.rowIcon} aria-hidden />
            <a href={doc.Path || '#'} style={styles.link} target="_blank" rel="noopener noreferrer">
              {doc.DocumentName}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}

CfsProtocolInsightCard.propTypes = {
  documents: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string.isRequired,
      href: PropTypes.string,
    }),
  ),
};

export default CfsProtocolInsightCard;
